import { ALL_GAME_NAMES, getGameSlug } from './allGames';
import { gameNameMap } from './gameDisplayNames';

export const CATALOG_CATEGORY_KEYS = ['currency', 'accounts', 'top-ups', 'items', 'boosting'];

const RESERVED_PATHS = new Set([
  'profile', 'admin', 'mod', 'auth', 'messages', 'cart', 'checkout', 'ad', 'orders',
  'seller', 'support', 'blog', 'about', 'help', 'terms', 'privacy', 'cookies', 'faq',
  'login', 'register', 'search', 'notifications', 'wallet', 'api', 'cases', 'boosting',
]);

const GAMES_WITHOUT_ACCOUNTS = new Set(['identity-v']);

const GAMES_WITH_CURRENCY = new Set([
  '8-ball-pool', 'albion-online', 'animal-crossing-new-horizons', 'arc-raiders',
  'black-desert-online', 'blade-soul-neo', 'blade-ball', 'creatures-of-sonaria',
  'dark-and-darker', 'dc-universe-online', 'delta-force', 'diablo-4',
  'digimon-super-rumble', 'dofus', 'donutsmp', 'dune-awakening',
  'ea-sports-fc', 'ea-sports-fc-mobile', 'elden-ring', 'elder-scrolls-online',
  'escape-from-tarkov', 'eve-echoes', 'eve-online', 'fallout-76', 'final-fantasy-xi',
  'final-fantasy-xiv', 'fisch', 'forza-horizon-5', 'grow-a-garden', 'growtopia',
  'guild-wars-2', 'hypixel', 'last-epoch', 'lost-ark', 'madden-nfl', 'maplestory',
  'minecraft', 'mortal-online-2', 'new-world', 'odin-valhalla-rising', 'old-school-runescape',
  'path-of-exile', 'path-of-exile-2', 'pet-simulator-99',
  'pets-go', 'pokemon-go', 'roblox', 'runescape-3', 'runescape-bonds',
  'star-citizen', 'swtor', 'temtem', 'throne-and-liberty',
  'toilet-tower-defense', 'torchlight-infinite', 'trove', 'warframe', 'warcraft',
  'wow-classic', 'wow-mists-of-pandaria',
]);

const GAMES_WITH_TOP_UPS = new Set([
  '99-nights-in-the-forest', 'amazon', 'anime-vanguards', 'apex-legends', 'arena-breakout',
  'arena-breakout-infinite', 'bigo-live', 'blood-strike', 'brawl-stars', 'call-of-duty-mobile',
  'cod-call-of-duty', 'call-of-duty', 'clash-of-clans', 'clash-royale', 'counter-strike-2',
  'crunchyroll', 'dead-by-daylight', 'delta-force', 'destiny-2', 'ea-play', 'ea-sports-fc',
  'efootball', 'elder-scrolls-online', 'escape-from-tarkov', 'etheria-restart', 'fortnite',
  'garena-free-fire', 'genshin-impact', 'grand-roleplay', 'growtopia', 'honkai-star-rail',
  'honor-of-kings', 'hypixel', 'identity-v', 'league-of-legends', 'league-of-legends-wild-rift',
  'love-and-deepspace', 'marvel-rivals', 'miliastra-wonderland', 'minecraft', 'mobile-legends',
  'nintendo', 'overwatch-2', 'path-of-exile-2', 'playstation', 'pokemon-go', 'pokemon-tcg-pocket',
  'poppo-live', 'pubg', 'pubg-mobile', 'rainbow-six-siege', 'rainbow-six-siege-x', 'roblox',
  'rocket-league', 'rust', 'sea-of-thieves', 'spotify', 'super-sus', 'tiktok', 'valorant',
  'whiteout-survival', 'world-of-warcraft', 'warcraft', 'wuthering-waves', 'youtube',
  'zenless-zone-zero',
]);

const GAMES_WITH_ITEMS = new Set([
  '8-ball-pool', 'adopt-me', 'albion-online', 'all-star-tower-defense-x', 'animal-crossing-new-horizons',
  'anime-defenders', 'anime-eternal', 'anime-fighting-simulator-endless', 'anime-last-stand',
  'anime-reborn', 'anime-vanguards', 'apex-legends', 'arc-raiders', 'ark-survival-ascended',
  'arknights', 'attack-on-titan-revolution', 'arena-breakout-infinite', 'ayakashi-rumble',
  'battlefield', 'battlenet', 'bee-swarm-simulator', 'black-clover-m', 'black-desert-online',
  'bleach-brave-souls', 'blade-ball', 'blood-strike', 'blox-fruits', 'blue-lock-rivals',
  'borderlands-4', 'brawl-stars', 'bubble-gum-simulator-infinity', 'build-a-zoo',
  'call-of-duty-mobile', 'car-parking-multiplayer', 'chaos-zero-nightmare', 'chocotto-land',
  'clash-royale', 'cod-call-of-duty', 'call-of-duty', 'clash-of-clans', 'cookie-run-kingdom',
  'counter-strike-2', 'cs2', 'creatures-of-sonaria', 'dark-and-darker',
  'darkorbit', 'dayz', 'dead-rails', 'delta-force', 'destiny-2',
  'diablo-2-resurrected', 'diablo-4', 'diablo-immortal', 'digimon-super-rumble', 'discord',
  'donutsmp', 'dota-2', 'dragon-ball-legends', 'dragon-ball-z-dokkan-battle',
  'dune-awakening', 'duet-night-abyss', 'ea-sports-fc', 'elden-ring',
  'elder-scrolls-online', 'epic-games', 'epic-seven', 'escape-from-tarkov', 'etheria-restart',
  'eve-online', 'fallout-76', 'fate-grand-order', 'final-fantasy-xiv', 'fisch', 'fish-it',
  'forza-horizon-5', 'fortnite', 'garden-tower-defense', 'garena-free-fire', 'genshin-impact',
  'girls-frontline-2-exilium', 'goddess-of-victory-nikke', 'golden-hoyeah', 'granblue-fantasy',
  'grand-piece-online', 'grand-roleplay', 'grand-theft-auto-5', 'grow-a-garden', 'growtopia',
  'guild-wars-2', 'hay-day', 'honkai-impact-3rd', 'houchi-shoujo',
  'hunty-zombie', 'hypixel', 'ink-game', 'jailbreak', 'jojo-s-bizarre-adventure-ora-ora-overdrive',
  'jujutsu-infinite', 'jujutsu-kaisen-phantom-parade', 'kaiju-no-8', 'king-legacy', 'knight-online',
  'knives-out', 'last-island-of-survival', 'league-of-legends',
  'livly-island', 'lords-mobile', 'lost-ark', 'madoka-magica-magia-exedra',
  'marvel-contest-of-champions', 'marvel-rivals', 'metin2', 'millennium-war-aigis', 'minecraft',
  'mobile-legends', 'monopoly-go', 'monster-hunter-now', 'monster-strike', 'murder-mystery-2',
  'murderers-vs-sheriffs-duels', 'netflix', 'new-world', 'old-school-runescape', 'one-piece-bounty-rush',
  'one-piece-treasure-cruise', 'origin', 'overwatch-2', 'path-of-exile', 'path-of-exile-2',
  'persona-5-the-phantom-x', 'pet-simulator-99', 'pets-go', 'plants-vs-brainrots',
  'pokecolo', 'pokecolo-twin', 'pokemon-go', 'pokemon-legends-z-a', 'pokemon-tcg-pocket',
  'princess-connect-re-dive', 'professional-baseball-spirits-a', 'project-sekai', 'pubg',
  'pubg-mobile', 'puzzle-and-dragons', 'raise-animals', 'raid-shadow-legends', 'rainbow-six-siege',
  'rise-of-kingdoms', 'roblox', 'roblox-limiteds', 'roblox-rivals',
  'royale-online', 'runescape-3', 'rust', 'sd-gundam-g-generation-eternal',
  'seven-knights-re-birth', 'shadowverse', 'silver-and-blood', 'sky-children-of-the-light',
  'standoff-2', 'steal-a-brainrot', 'stella-sora', 'summoners-war',
  'team-fortress-2', 'the-finals', 'the-forge', 'the-seven-deadly-sins', 'throne-and-liberty',
  'tips-jar', 'tower-of-fantasy', 'twitch-drops', 'ubisoft-connect', 'uma-musume-pretty-derby',
  'universal-tower-defense', 'unveil-the-world', 'valorant', 'volleyball-legends', 'war-thunder',
  'wartune-ultra', 'watcher-of-realms', 'warframe', 'where-winds-meet', 'white-cat-project',
  'wolfteam', 'world-of-tanks', 'world-of-warships', 'world-of-warcraft',
  'warcraft', 'wow-classic', 'wow-mists-of-pandaria', 'wuthering-waves',
  'yo-kai-watch-wibble-wobble', 'yu-gi-oh-master-duel', 'zula',
]);

const GAMES_WITH_BOOSTING = new Set([
  'anime-vanguards', 'apex-legends', 'arc-raiders', 'arena-breakout', 'arena-breakout-infinite',
  'battlefield', 'black-desert-online', 'blox-fruits', 'brawl-stars', 'call-of-duty-mobile',
  'cod-call-of-duty', 'call-of-duty', 'clash-of-clans', 'clash-royale', 'counter-strike-2', 'cs2',
  'dead-by-daylight', 'deadlock', 'delta-force', 'destiny-2', 'diablo-4',
  'donutsmp', 'dota-2', 'ea-sports-fc', 'elder-scrolls-online', 'escape-from-tarkov',
  'final-fantasy-xiv', 'fisch', 'fortnite', 'genshin-impact', 'grand-roleplay', 'league-of-legends',
  'league-of-legends-wild-rift', 'marvel-rivals', 'minecraft', 'mobile-legends', 'monster-hunter-wilds',
  'new-world', 'old-school-runescape', 'overwatch-2', 'path-of-exile', 'path-of-exile-2',
  'pokemon-go', 'rainbow-six-siege', 'rainbow-six-siege-x', 'roblox', 'rocket-league', 'runescape-3', 'rust',
  'teamfight-tactics', 'the-first-descendant', 'the-forge', 'throne-and-liberty', 'valorant',
  'warframe', 'where-winds-meet', 'world-of-warcraft', 'warcraft', 'wow-classic',
  'wow-mists-of-pandaria',
]);

const CURRENCY_NAME_MAP = {
  '8-ball-pool': 'Coins',
  'albion-online': 'Silver',
  'animal-crossing-new-horizons': 'Bells',
  'arc-raiders': 'Coins',
  'black-desert-online': 'Silver',
  'blade-soul-neo': 'Divine Gems',
  'blade-ball': 'Tokens',
  'creatures-of-sonaria': 'Mushrooms',
  'dark-and-darker': 'Gold',
  'dc-universe-online': 'Cash',
  'delta-force': 'Tekniq Alloy',
  'diablo-4': 'Gold',
  'digimon-super-rumble': 'Bits',
  'dofus': 'Kamas',
  'donutsmp': 'Money',
  'dune-awakening': 'Solaris',
  'ea-sports-fc': 'Coins',
  'ea-sports-fc-mobile': 'Coins',
  'elden-ring': 'Runes',
  'elder-scrolls-online': 'Gold',
  'escape-from-tarkov': 'Roubles',
  'eve-echoes': 'ISK',
  'eve-online': 'ISK',
  'fallout-76': 'Caps',
  'final-fantasy-xi': 'Gil',
  'final-fantasy-xiv': 'Gil',
  'fisch': 'Money',
  'forza-horizon-5': 'Credits',
  'grow-a-garden': 'Tokens',
  'growtopia': 'Locks',
  'guild-wars-2': 'Gold',
  'hypixel': 'Coins',
  'last-epoch': 'Gold',
  'lost-ark': 'Gold',
  'madden-nfl': 'Coins',
  'maplestory': 'Mesos',
  'minecraft': 'Hypixel Coins',
  'mortal-online-2': 'Gold',
  'new-world': 'Coins',
  'odin-valhalla-rising': 'Diamonds',
  'old-school-runescape': 'Gold',
  'path-of-exile': 'Currency',
  'path-of-exile-2': 'Currency',
  'pet-simulator-99': 'Gems',
  'pets-go': 'Diamonds',
  'pokemon-go': 'Stardust',
  'roblox': 'Robux',
  'runescape-3': 'Gold',
  'runescape-bonds': 'Bonds',
  'star-citizen': 'aUEC',
  'swtor': 'Credits',
  'temtem': 'Pansun',
  'throne-and-liberty': 'Lucent',
  'toilet-tower-defense': 'Gems',
  'torchlight-infinite': 'Flame Elementium',
  'trove': 'Flux',
  'warframe': 'Platinum',
  'warcraft': 'Gold',
  'wow-classic': 'Gold',
  'wow-mists-of-pandaria': 'Gold',
};

const TOP_UPS_NAME_MAP = {
  '99-nights-in-the-forest': 'Diamonds',
  amazon: 'Subscription',
  'apex-legends': 'Top Ups',
  'arena-breakout': 'Top Ups',
  'bigo-live': 'Diamonds',
  'blood-strike': 'Gold',
  'brawl-stars': 'Gems',
  'call-of-duty-mobile': 'CP',
  'cod-call-of-duty': 'Points',
  'call-of-duty': 'Points',
  'clash-of-clans': 'Gems',
  'clash-royale': 'Gems',
  crunchyroll: 'Subscription',
  'dead-by-daylight': 'Auric Cells',
  'delta-force': 'Delta Coins',
  'destiny-2': 'Silver',
  'ea-play': 'Subscription',
  'ea-sports-fc': 'Points',
  efootball: 'Coins',
  'elder-scrolls-online': 'Crowns',
  'etheria-restart': 'Crystals',
  fortnite: 'V-Bucks',
  'garena-free-fire': 'Diamonds',
  'genshin-impact': 'Top Ups',
  growtopia: 'Gems',
  'honkai-star-rail': 'Oneiric Shards',
  'honor-of-kings': 'Tokens',
  'identity-v': 'Echoes',
  'league-of-legends': 'Riot Points',
  'league-of-legends-wild-rift': 'Wild Cores',
  'love-and-deepspace': 'Crystals',
  'marvel-rivals': 'Lattice',
  'miliastra-wonderland': 'Chronal Nexus',
  minecraft: 'Minecoins',
  'mobile-legends': 'Diamonds',
  nintendo: 'Subscription',
  'overwatch-2': 'Coins',
  'path-of-exile-2': 'Points',
  playstation: 'Subscription',
  'pokemon-go': 'Top Ups',
  'pokemon-tcg-pocket': 'Poke Gold',
  'poppo-live': 'Coins',
  pubg: 'G-Coins',
  'pubg-mobile': 'UC',
  'rainbow-six-siege-x': 'Credits',
  roblox: 'Top Ups',
  'rocket-league': 'Credits',
  rust: 'Coins',
  'sea-of-thieves': 'Ancient Coins',
  spotify: 'Subscription',
  'super-sus': 'Goldstars',
  tiktok: 'Coins',
  valorant: 'Points',
  'whiteout-survival': 'Frost Stars',
  'world-of-warcraft': 'Subscription',
  warcraft: 'Subscription',
  'wuthering-waves': 'Lunites',
  youtube: 'Subscription',
  'zenless-zone-zero': 'Monochromes',
};

export const RELATED_CATALOG_GAMES = [
  { slug: 'roblox', name: 'Roblox' },
  { slug: 'fortnite', name: 'Fortnite' },
  { slug: 'valorant', name: 'Valorant' },
  { slug: 'minecraft', name: 'Minecraft' },
  { slug: 'counter-strike-2', name: 'Counter-Strike 2' },
  { slug: 'brawl-stars', name: 'Brawl Stars' },
  { slug: 'discord', name: 'Discord' },
  { slug: 'pubg-mobile', name: 'PUBG Mobile' },
  { slug: 'league-of-legends', name: 'League of Legends' },
  { slug: 'genshin-impact', name: 'Genshin Impact' },
  { slug: 'mobile-legends', name: 'Mobile Legends' },
  { slug: 'marvel-rivals', name: 'Marvel Rivals' },
  { slug: 'clash-royale', name: 'Clash Royale' },
  { slug: 'clash-of-clans', name: 'Clash of Clans' },
  { slug: 'spotify', name: 'Spotify' },
  { slug: 'netflix', name: 'Netflix' },
];

let knownSlugSet = null;

function titleCaseSlug(slug) {
  return String(slug || '')
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function normalizeGameSlug(slug) {
  return slug === 'cs2' ? 'counter-strike-2' : slug;
}

export function isKnownGameSlug(slug) {
  if (!slug) return false;
  if (!knownSlugSet) {
    knownSlugSet = new Set([
      ...Object.keys(gameNameMap),
      ...ALL_GAME_NAMES.map(getGameSlug),
      'cs2',
      'call-of-duty',
    ]);
  }
  return knownSlugSet.has(slug) || knownSlugSet.has(normalizeGameSlug(slug));
}

function hasCategory(set, slug) {
  return set.has(slug) || set.has(normalizeGameSlug(slug));
}

export function getGameServiceCategories(slug) {
  if (!slug) return [];
  const services = [];

  if (hasCategory(GAMES_WITH_CURRENCY, slug)) {
    services.push({
      key: 'currency',
      name: CURRENCY_NAME_MAP[slug] || CURRENCY_NAME_MAP[normalizeGameSlug(slug)] || 'Currency',
      path: `/${slug}/currency`,
    });
  }

  if (!GAMES_WITHOUT_ACCOUNTS.has(slug) && !GAMES_WITHOUT_ACCOUNTS.has(normalizeGameSlug(slug))) {
    services.push({
      key: 'accounts',
      name: 'Accounts',
      path: `/${slug}/accounts`,
    });
  }

  if (hasCategory(GAMES_WITH_TOP_UPS, slug)) {
    services.push({
      key: 'top-ups',
      name: TOP_UPS_NAME_MAP[slug] || TOP_UPS_NAME_MAP[normalizeGameSlug(slug)] || 'Top Ups',
      path: `/${slug}/top-ups`,
    });
  }

  if (hasCategory(GAMES_WITH_ITEMS, slug)) {
    services.push({
      key: 'items',
      name: 'Items',
      path: `/${slug}/items`,
    });
  }

  if (hasCategory(GAMES_WITH_BOOSTING, slug)) {
    services.push({
      key: 'boosting',
      name: 'Boosting',
      path: `/${slug}/boosting`,
    });
  }

  return services;
}

export function getGameDisplayName(slug) {
  return gameNameMap[slug] || gameNameMap[normalizeGameSlug(slug)] || titleCaseSlug(slug);
}

function getCategoryLabel(slug, category, services) {
  const match = services.find((service) => service.key === category);
  if (match) return match.name;
  if (category === 'currency') {
    return CURRENCY_NAME_MAP[slug] || CURRENCY_NAME_MAP[normalizeGameSlug(slug)] || 'Currency';
  }
  if (category === 'top-ups') {
    return TOP_UPS_NAME_MAP[slug] || TOP_UPS_NAME_MAP[normalizeGameSlug(slug)] || 'Top Ups';
  }
  if (category === 'items') return 'Items';
  if (category === 'boosting') return 'Boosting';
  return 'Accounts';
}

function getPageTitle(gameName, category, categoryLabel) {
  if (category === 'top-ups') return `Topping up ${gameName}`;
  if (category === 'currency') return `${gameName} ${categoryLabel}`;
  if (category === 'items') return `${gameName} items`;
  if (category === 'boosting') return `${gameName} boosting`;
  return `${gameName} accounts`;
}

function getPageDescription(gameName, category, categoryLabel) {
  if (category === 'top-ups') {
    return `Top up ${gameName} from verified sellers. Fast delivery, TradeShield protection, and 24/7 support.`;
  }
  if (category === 'currency') {
    return `Buy ${gameName} ${categoryLabel} from verified sellers. Compare prices, stock, and delivery speed.`;
  }
  if (category === 'items') {
    return `Browse ${gameName} items from trusted sellers. Filter by type, platform, and price.`;
  }
  if (category === 'boosting') {
    return `Order ${gameName} boosting from verified players. Set your rank, platform, and delivery window.`;
  }
  return `Buy ${gameName} accounts from verified sellers. Filter by platform, rank, and price.`;
}

function getGuide(gameName, category, categoryLabel) {
  if (category === 'top-ups') {
    return {
      title: `How to top up ${gameName} on XMARKET`,
      steps: [
        `Pick the ${categoryLabel} amount you want.`,
        'Choose a verified seller and pay through TradeShield.',
        'Follow the delivery instructions and receive your top-up.',
      ],
    };
  }
  if (category === 'currency') {
    return {
      title: `How to buy ${gameName} ${categoryLabel}`,
      steps: [
        'Select server, platform, or region if the game uses them.',
        'Compare sellers by stock, rating, and price per unit.',
        'Pay through TradeShield and receive delivery in-game.',
      ],
    };
  }
  if (category === 'boosting') {
    return {
      title: `How ${gameName} boosting works`,
      steps: [
        'Choose the boost type and your current / desired rank.',
        'Post a request and wait for verified boosters to offer.',
        'Pay through TradeShield and track progress in chat.',
      ],
    };
  }
  if (category === 'items') {
    return {
      title: `How to buy ${gameName} items`,
      steps: [
        'Filter items by type, platform, and price.',
        'Open an offer and check the seller rating.',
        'Pay through TradeShield and receive delivery.',
      ],
    };
  }
  return {
    title: `How to buy ${gameName} accounts`,
    steps: [
      'Use filters to match platform, rank, and budget.',
      'Open an account offer and review the screenshots.',
      'Pay through TradeShield and receive login details.',
    ],
  };
}

export function getGameCatalogMeta(slug, category = 'accounts') {
  const services = getGameServiceCategories(slug);
  const safeCategory = CATALOG_CATEGORY_KEYS.includes(category) ? category : 'accounts';
  const gameName = getGameDisplayName(slug);
  const categoryLabel = getCategoryLabel(slug, safeCategory, services);
  return {
    slug,
    category: safeCategory,
    gameName,
    categoryLabel,
    services,
    title: getPageTitle(gameName, safeCategory, categoryLabel),
    description: getPageDescription(gameName, safeCategory, categoryLabel),
    guide: getGuide(gameName, safeCategory, categoryLabel),
  };
}

export function parseCatalogPath(pathname) {
  const parts = String(pathname || '').split('/').filter(Boolean);
  if (!parts.length) return null;
  if (RESERVED_PATHS.has(parts[0])) return null;
  if (!isKnownGameSlug(parts[0])) return null;
  if (parts.length === 1) {
    return { slug: parts[0], category: 'accounts' };
  }
  if (parts.length === 2 && CATALOG_CATEGORY_KEYS.includes(parts[1])) {
    return { slug: parts[0], category: parts[1] };
  }
  return null;
}

export function isCatalogListingPath(pathname) {
  return Boolean(parseCatalogPath(pathname));
}

export function isMarketplaceChromePath(pathname) {
  const path = String(pathname || '');
  if (path.startsWith('/admin') || path.startsWith('/mod')) return false;
  return true;
}

export function getCatalogPageMeta(pathname) {
  const parsed = parseCatalogPath(pathname);
  if (!parsed) return null;
  return getGameCatalogMeta(parsed.slug, parsed.category);
}

export function getRelatedCatalogGames(slug, category) {
  return RELATED_CATALOG_GAMES
    .filter((game) => game.slug !== slug && game.slug !== normalizeGameSlug(slug))
    .map((game) => {
      const services = getGameServiceCategories(game.slug);
      const match = services.find((service) => service.key === category) || services[0];
      return match
        ? { ...game, path: match.path, label: match.name }
        : { ...game, path: `/${game.slug}/accounts`, label: 'Accounts' };
    });
}
